import { RootState } from '../store';

export const selectMaintenanceStatus = (state: RootState): boolean =>
  state.maintenanceSlice.isMaintenanceMode;

export const selectMaintenanceErrorCount = (state: RootState): number =>
  state.maintenanceSlice.errorCount;

export const selectMaintenanceLastErrorStatus = (state: RootState): number | undefined =>
  state.maintenanceSlice.lastErrorStatus; 